import React, { useState, useEffect, useRef } from 'react'
import styles from './Home.module.scss'
import { FranchiseePageResult, intentionService } from '../join/intention/intentionService'
import { Table } from 'antd'
import { useDictModel } from '../base/dict/dictModel'

export function Home() {
    const { getTreeNodeName } = useDictModel()
    const [tableList, setTableList] = useState<FranchiseePageResult[]>([])
    const [center, setCenter] = useState<any>({ longitude: 115, latitude: 40 })
    const [markerList, setMarkerList] = useState<(FranchiseePageResult & { position: any })[]>([])
    const mapRef = useRef<any>(null)
    const markersRef = useRef<any>(null)
    const infoWindowRef = useRef<any>(null)
    

    const getjoinsList = async (type) => {
        let TMap = (window as any).TMap
        if (!TMap) {
            return setTimeout(() => {
                getjoinsList(type)
            }, 200)
        }
        let status = type === 'map' ? ['franchisee-status.completed'] : ['franchisee-status.init']
        const searchParams = {
            searchItem: {
                status,
                franchiseType: type === 'table' ? 'franchisee.settle' : '',
            },
            pageSize: 100000,
            pageNum: 1,
            orders: [],
        }
        let { retData } = await intentionService.page(searchParams)
        const { list } = retData
        type === 'map'
            ? setMarkerList(list.map((i) => ({ ...i, styleId: 'marker', position: new TMap.LatLng(i.latitude, i.longitude) })))
            : setTableList(list)
    }

    const initMap = () => {
        let TMap = (window as any).TMap
        if (!document.getElementById('container') || !TMap) {
            return setTimeout(() => {
                initMap()
            }, 100)
        }
        setTimeout(() => {
            mapRef.current = new TMap.Map(document.getElementById('container'), {
                center: new TMap.LatLng(center.latitude, center.longitude),
                zoom: 10,
                noClear: false,
            })
        }, 500)
    }

    const updateMakers = (makers) => {
        let TMap = (window as any).TMap
        if (makers.length === 0) {
            return
        }
        if (!mapRef.current || !TMap) {
            return setTimeout(() => {
                updateMakers(makers)
            }, 200)
        }
        mapRef.current.setCenter(makers[0].position)
        markersRef.current && markersRef.current.setMap(null)
        markersRef.current = new TMap.MultiMarker({
            id: 'marker-layer',
            map: mapRef.current,
            geometries: makers,
        })
        markersRef.current.on('click', handleMarkerClick)
    }

    const handleMarkerClick = (evt) => {
        let TMap = (window as any).TMap
        const { name, address, position} = evt.geometry
        mapRef.current.setCenter(position)
        infoWindowRef.current = new TMap.InfoWindow({
            map: mapRef.current,
            position: position,
            offset: { x: 0, y: -32 },
            content: `<div class="window-warp">
            <h4>${name}</h4>
            <div class="window-content">
                <p>位置：<span>${address}</span></p>
            </div>
        </div>`,
        })
    }

    useEffect(() => {
        updateMakers(markerList)
    }, [markerList])

    useEffect(() => {
        initMap()
        getjoinsList('map')
        getjoinsList('table')
    }, [])


    const columns = [
        {
            title: '加盟商名称',
            width: 140,
            dataIndex: 'name',
            // isSet: true,
            // sorter: true,
            // render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },

        {
            title: '电话',
            width: 140,
            dataIndex: 'phone',
            // isSet: true,
            // sorter: true,
            // render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '加盟意向',
            width: 110,
            dataIndex: 'followUpList',
            // isSet: true,
            // sorter: true,
            render: (text) => (text?.length > 0 ? getTreeNodeName(text[text.length - 1].intentionLevel) : '未跟进'),
        },
    ]

    return (
        <div className={styles['home']}>
            <div className={styles['map-box']} id="container"></div>
            {/* <div className={styles['agency-handling']}>
                <Table
                    rowKey={(record) => record.id}
                    columns={columns}
                    scroll={{ x: 'max-content', y: 'calc(100vh - 380px)' }}
                    dataSource={tableList}
                    bordered
                    pagination={false}
                />
            </div> */}
        </div>
    )
}
